import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

export const useStyles = createStyles(({ css }: any) => ({
  drawer: css``,
}));

export const useModalUserRemoveStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
